import { useSyncExternalStore } from 'react';

const subscribe = (callback: () => void): (() => void) => {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
};

const getSnapshot = (): boolean => (typeof navigator === 'undefined' ? true : navigator.onLine !== false);

/** A böngésző hálózati állapota (navigator.onLine + online/offline események). */
export const useOnlineStatus = (): boolean => useSyncExternalStore(subscribe, getSnapshot, () => true);

export default useOnlineStatus;
